module.exports = __webpack_public_path__ + "img/Compact-User.6494c772.jpg";